import React, { useState } from "react";

import { Modal, Button, Table } from "antd";

const DataModal = ({ isVisible, onClose, custom1Data, custom2Data, handleApplyFilter }) => {
    const [activeTab, setActiveTab] = useState("users");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedReferral, setSelectedReferral] = useState([]);
    
    const rowSelection = {
        onChange: (selectedRowKeys) => {
            if (activeTab === "users") {
                setSelectedUsers(selectedRowKeys);
            } else if (activeTab === "referral") {
                setSelectedReferral(selectedRowKeys);
            }
        },
        selectedRowKeys: activeTab === "users" ? selectedUsers : selectedReferral,
    };

    // Handle Apply Filter
    const applyFilter = () => {
        if (typeof handleApplyFilter === "function") {
            handleApplyFilter({
                users: selectedUsers,
                referral: selectedReferral,
            });
        }
        onClose();
    };

    return (
        <Modal
            title="Data Modal"
            open={isVisible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Close
                </Button>,
                <Button key="apply" type="primary" onClick={applyFilter}>
                    Add Filter
                </Button>,
            ]}
            bodyStyle={{ maxHeight: "400px", overflowY: "auto" }}
        >
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
                <Button
                    type={activeTab === "users" ? "primary" : "default"}
                    onClick={() => setActiveTab("users")}
                >
                    Users
                </Button>
                <Button
                    type={activeTab === "referral" ? "primary" : "default"}
                    onClick={() => setActiveTab("referral")}
                >
                    Referral
                </Button>
            </div>

            <Table
                rowSelection={rowSelection}
                dataSource={activeTab === "users" ? custom1Data : custom2Data}
                columns={[
                    {
                        title: activeTab === "users" ? "UserId" : "Referrer",
                        dataIndex: "value",
                        key: "value",
                        render: (value) => (value === null ? "null" : value),
                    },
                    {
                        title: activeTab === "users" ? "Views" : "Views",
                        dataIndex: "total_count",
                        key: "total_count",
                        render: (total_count) => (total_count === null ? "null" : total_count),
                    },
                ]}
                pagination={false}
                rowKey={(record) => record.value}
            />
        </Modal>
    );
};

export default DataModal;
